<template>
  <div id="mobile-map-draw">
    <div class="map-container">
      <div id="map" ref="map"></div>

      <!-- 移动端顶部工具栏 -->
      <!-- <div class="mobile-toolbar">
        <div class="toolbar-header">
          <div class="title">地图测量工具</div>
          <el-button class="back-btn" size="mini" @click="goBack">返回</el-button>
        </div>
      </div> -->

      <!-- 移动端底部操作栏 -->
      <div class="mobile-controls">
        <div class="control-buttons">
          <button class="control-btn" @click="toggleDrawMode('polygon')" :class="{ active: drawMode === 'polygon' }">
            <span class="btn-icon">📐</span>
            <span class="btn-text">多边形</span>
          </button>

          <button class="control-btn" @click="undoStep">
            <span class="btn-icon">↩</span>
            <span class="btn-text">上一步</span>
          </button>

          <button class="control-btn" @click="finishDraw">
            <span class="btn-icon">✅️</span>
            <span class="btn-text">完成</span>
          </button>

          <button class="control-btn" @click="clearAll">
            <span class="btn-icon">🗑️</span>
            <span class="btn-text">清除</span>
          </button>

          <button class="control-btn" @click="openSaveDialog">
            <span class="btn-icon">💾</span>
            <span class="btn-text">保存</span>
          </button>
        </div>
      </div>

      <!-- 缩放控制 -->
      <div class="zoom-controls">
        <button class="zoom-btn" @click="locateUser">📍</button>
        <button class="zoom-btn" @click="zoomIn">+</button>
        <button class="zoom-btn" @click="zoomOut">-</button>
      </div>

      <!-- 操作提示 -->
      <div class="hint-tooltip" v-if="showHint">
        <div class="hint-content">
          {{ hintText }}
        </div>
      </div>
      <!-- 保存信息弹窗 -->
      <el-dialog title="保存地块信息" :visible.sync="dialogVisible" width="90%" :modal-append-to-body="false"
                 :close-on-click-modal="false" class="mobile-save-dialog">
        <el-form :model="formData" label-width="100px" label-position="left">
          <el-form-item label="名称">
            <el-input v-model="formData.name" placeholder="请输入地块名称" />
          </el-form-item>

          <el-form-item label="土地性质">
            <el-select v-model="formData.landType" placeholder="请选择土地性质" clearable>
              <el-option
                  v-for="dict in landStatusValue"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="土地使用年限">
            <el-input-number v-model="formData.years" :min="0" :max="100" style="width:100%" />
          </el-form-item>

          <el-form-item label="联系人电话" prop="contact">
            <el-input v-model="formData.contact" placeholder="仅后台使用" />
          </el-form-item>

          <el-form-item label="备注" prop="remarks">
            <el-input type="textarea" v-model="formData.remarks" :rows="3" placeholder="仅后台使用" />
          </el-form-item>

          <el-form-item label="文件">
            <FileUploader
                v-model="formData.files"
                :action="uploadImgUrl"
                :limit="5"
                :file-size="5"
                :file-type="['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx']"
                list-type="picture-card"
                :show-tip="true"
            />
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="saveFormData">确认</el-button>
          </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
import FileUploader from '@/components/upload/fileUploader.vue'
import { addAlternativeSites,getDicts } from '@/api/holdMy'
import {ref} from "vue";

export default {
  name: 'MobileMapDraw',
  components: {
    FileUploader
  },
  data() {
    return {
      map: null,
      drawnItems: null,
      currentPolygon: null,
      drawMode: null,
      drawControl: null,
      perimeter: 0,
      area: 0,
      areaMu: 0,
      sideLengths: [],
      centerLabel: null,
      sideLabels: [],
      areaLabels: [], // 新增：用于显示面积标签
      showHint: false,
      hintText: '',
      userMarker: null,
      userLocation: null,
      currentHandler: null,    // 当前活动的绘制处理器
      canUndo: false,           // 控制撤销按钮是否可点击（可选）
      dialogVisible: false,
      formData: {
        name: '',
        landType: '',
        years: null,
        contact: '',
        remarks: '',
        files: []
      },
      uploadImgUrl: "/dev-api/common/upload",
      landStatusValue: null,
    }
  },
  mounted() {
    this.getDicts()
    this.initMap()
    this.setupMobileEvents()
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove()
    }
    this.clearLabels()
  },
  methods: {
    initMap() {
      this.map = L.map(this.$refs.map, {
        zoomControl: false,
        touchZoom: true,
        scrollWheelZoom: false,
        dragging: true,
        tap: true,
        attributionControl: false
      }).setView([24.4798, 118.0894], 10)

      // 添加卫星图层 - 使用高德卫星地图
      L.tileLayer('http://webst0{s}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}', {
        subdomains: ['1', '2', '3', '4'],
        attribution: '高德地图'
      }).addTo(this.map)

      // 添加标注图层（可选，显示地名等）
      L.tileLayer('http://webst0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}', {
        subdomains: ['1', '2', '3', '4']
      }).addTo(this.map)

      // 初始化绘制图层
      this.drawnItems = new L.FeatureGroup()
      this.map.addLayer(this.drawnItems)

      this.configureDrawControl()
      this.addUserLocationMarker()
      this.showHintMessage('点击下方按钮开始测量，双指缩放地图')
    },

    configureDrawControl() {
      /*L.drawLocal.draw.toolbar.buttons.polygon = '多边形'
      L.drawLocal.draw.toolbar.buttons.rectangle = '矩形'*/
      L.drawLocal.draw.handlers.polygon.tooltip.start = '点击开始绘制'
      L.drawLocal.draw.handlers.polygon.tooltip.cont = '点击继续绘制'
      L.drawLocal.draw.handlers.polygon.tooltip.end = '点击第一个点完成'
      /*L.drawLocal.draw.handlers.rectangle.tooltip.start = '拖动绘制矩形'*/

      // 补充汉化：编辑工具栏按钮
      /*L.drawLocal.edit.toolbar.buttons.edit = '编辑图形'
      L.drawLocal.edit.toolbar.buttons.editDisabled = '没有可编辑的图形'
      L.drawLocal.edit.toolbar.buttons.remove = '删除图形'
      L.drawLocal.edit.toolbar.buttons.removeDisabled = '没有可删除的图形'

      // 补充汉化：编辑模式提示
      L.drawLocal.edit.handlers.edit.tooltip.text = '拖动点或边来编辑图形'
      L.drawLocal.edit.handlers.edit.tooltip.subtext = '点击取消撤销更改'
      L.drawLocal.edit.handlers.remove.tooltip.text = '点击图形删除'
*/
      // 补充汉化：操作按钮（取消、完成、撤销）
      L.drawLocal.draw.toolbar.actions.title = '取消绘制'
      L.drawLocal.draw.toolbar.actions.text = '取消'
      L.drawLocal.draw.toolbar.finish.title = '完成绘制'
      L.drawLocal.draw.toolbar.finish.text = '完成'
      L.drawLocal.draw.toolbar.undo.title = '撤销最后一步'
      L.drawLocal.draw.toolbar.undo.text = '撤销'

      // 可选：多边形交叉提示
      //L.drawLocal.draw.handlers.polygon.tooltip.intersect = '不能与自身相交'

      this.drawControl = new L.Control.Draw({
        position: 'topleft',
        draw: {
          polygon: {
            allowIntersection: false,
            drawError: {
              color: '#e74c3c',
              message: '不能与自身相交!'
            },
            showArea: false, // 禁用默认的面积显示
            shapeOptions: {
              color: 'blue',
              weight: 3,
              fillOpacity: 0.2
            },
            metric: true
          },
          rectangle: false,
          polyline: false,
          circle: false,
          circlemarker: false,
          marker: false
        },
        edit: {
          featureGroup: this.drawnItems,
          edit: false,
          remove: false
        }
      })

      // 监听绘制完成事件
      this.map.on(L.Draw.Event.CREATED, (e) => {
        const layer = e.layer
        this.clearAll()
        this.drawnItems.addLayer(layer)
        this.currentPolygon = layer

        // 为图形添加样式
        if (layer instanceof L.Polygon) {
          layer.setStyle({
            color: '#1890ff',
            weight: 3,
            fillColor: '#1890ff',
            fillOpacity: 0.2
          })
        }

        this.calculateMeasurements(layer)
        this.showHintMessage('测量完成！结果已显示在图形上')
      })


      // 监听编辑事件
      this.map.on(L.Draw.Event.EDITED, (e) => {
        const layers = e.layers
        layers.eachLayer((layer) => {
          this.currentPolygon = layer
          this.calculateMeasurements(layer)
        })
        this.showHintMessage('图形已更新')
      })

      // 监听删除事件
      this.map.on(L.Draw.Event.DELETED, () => {
        this.clearAll()
        this.showHintMessage('已清除图形')
      })
    },

    calculateMeasurements(layer) {
      if (layer instanceof L.Polygon || layer instanceof L.Rectangle) {
        let latlngs = layer.getLatLngs()[0]

        // 如果是矩形，转为4个点
        if (layer instanceof L.Rectangle) {
          const bounds = layer.getBounds()
          const ne = bounds.getNorthEast()
          const sw = bounds.getSouthWest()
          latlngs = [
            L.latLng(ne.lat, sw.lng), // 左上角
            L.latLng(ne.lat, ne.lng), // 右上角
            L.latLng(sw.lat, ne.lng), // 右下角
            L.latLng(sw.lat, sw.lng)  // 左下角
          ]
        }

        // 计算各边长度
        this.calculateSideLengths(latlngs)

        // 计算周长
        this.perimeter = this.sideLengths.reduce((sum, side) => sum + side.distance, 0)

        // 计算面积
        this.area = this.calculateArea(latlngs)

        // 计算亩数
        this.areaMu = this.area * 0.0015

        // 清除之前的标签
        this.clearLabels()

        // 在图形上显示结果
        this.addAreaLabel(layer, latlngs) // 显示面积标签
        this.addSideLabels(latlngs)       // 显示边长标签
      }
    },

    calculateSideLengths(latlngs) {
      this.sideLengths = []

      for (let i = 0; i < latlngs.length; i++) {
        const p1 = latlngs[i]
        const p2 = latlngs[(i + 1) % latlngs.length]

        // 计算距离
        const distance = this.calculateDistance(p1, p2)

        // 计算方位角
        let angle = null
        if (latlngs.length > 2) {
          angle = this.calculateAngle(p1, p2)
        }

        this.sideLengths.push({
          distance: distance,
          angle: angle,
          from: { lat: p1.lat, lng: p1.lng },
          to: { lat: p2.lat, lng: p2.lng }
        })
      }
    },

    calculateDistance(latlng1, latlng2) {
      const R = 6371000
      const lat1 = latlng1.lat * Math.PI / 180
      const lat2 = latlng2.lat * Math.PI / 180
      const deltaLat = (latlng2.lat - latlng1.lat) * Math.PI / 180
      const deltaLng = (latlng2.lng - latlng1.lng) * Math.PI / 180

      const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.cos(lat1) * Math.cos(lat2) *
        Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

      return R * c
    },

    calculateAngle(p1, p2) {
      const lat1 = p1.lat * Math.PI / 180
      const lat2 = p2.lat * Math.PI / 180
      const lon1 = p1.lng * Math.PI / 180
      const lon2 = p2.lng * Math.PI / 180

      const y = Math.sin(lon2 - lon1) * Math.cos(lat2)
      const x = Math.cos(lat1) * Math.sin(lat2) -
        Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)

      let angle = Math.atan2(y, x) * 180 / Math.PI
      angle = (angle + 360) % 360

      return angle
    },

    calculateArea(latlngs) {
      const R = 6371000
      let area = 0

      if (latlngs.length > 2) {
        for (let i = 0; i < latlngs.length; i++) {
          const p1 = latlngs[i]
          const p2 = latlngs[(i + 1) % latlngs.length]
          area += (p2.lng - p1.lng) * Math.PI / 180 *
            (2 + Math.sin(p1.lat * Math.PI / 180) +
              Math.sin(p2.lat * Math.PI / 180))
        }
        area = Math.abs(area * R * R / 2)
      }

      return area
    },

    // 在图形上添加面积标签（直接显示在图形内）
    addAreaLabel(layer, latlngs) {
      // 计算图形的中心点
      const bounds = layer.getBounds()
      let center = bounds.getCenter()
      //  计算中心点（多边形质心
      center = this.calculatePolygonCenter(latlngs)
      // 创建面积标签
      const areaIcon = L.divIcon({
        className: 'area-label',
        html: `
          <div class="area-label-content">
            <div class="area-main">面积:${this.areaMu.toFixed(2)}亩</div>
            <div class="area-main">面积:${this.formatArea(this.area)}</div>
            <div class="area-main">周长: ${this.formatDistance(this.perimeter)}</div>
          </div>
        `,
        iconSize: [180, 40],
        iconAnchor: [80, 30]
      })

      const areaLabel = L.marker([center.lat, center.lng], {
        icon: areaIcon,
        interactive: false
      }).addTo(this.map)

      this.areaLabels.push(areaLabel)
    },

    calculatePolygonCenter(latlngs) {
      // 计算多边形的质心
      let sumX = 0, sumY = 0
      latlngs.forEach(point => {
        sumX += point.lng
        sumY += point.lat
      })

      return L.latLng(sumY / latlngs.length, sumX / latlngs.length)
    },

    // 添加边标签
    addSideLabels(latlngs) {
      for (let i = 0; i < this.sideLengths.length; i++) {
        const side = this.sideLengths[i]
        const p1 = latlngs[i]
        const p2 = latlngs[(i + 1) % latlngs.length]

        // 计算边的中点（稍微向内偏移，避免重叠）
        const midPoint = this.calculateMidPointWithOffset(p1, p2, i)

        // 创建边标签
        const icon = L.divIcon({
          className: 'side-label',
          html: `
            <div class="side-label-content">
              <div class="side-length">${this.formatDistance(side.distance)}</div>
            </div>
          `,
          iconSize: [60, 30],
          iconAnchor: [30, 15]
        })

        const label = L.marker([midPoint.lat, midPoint.lng], {
          icon,
          interactive: false
        }).addTo(this.map)

        this.sideLabels.push(label)
      }
    },

    calculateMidPointWithOffset(p1, p2, index) {
      // 计算中点
      const midLat = (p1.lat + p2.lat) / 2
      const midLng = (p1.lng + p2.lng) / 2

      // 计算边的角度
      const angle = this.calculateAngle(p1, p2)

      // 根据边的角度和索引，稍微向内偏移标签，避免重叠
      const offsetDistance = 0.0001 // 大约10米

      // 计算偏移方向（垂直于边向内）
      let offsetAngle = angle - 90
      if (offsetAngle < 0) offsetAngle += 360

      // 根据索引交替偏移方向，避免重叠
      if (index % 2 === 0) {
        offsetAngle = (offsetAngle + 180) % 360
      }

      // 计算偏移后的位置
      const offsetLat = midLat + (offsetDistance * Math.cos(offsetAngle * Math.PI / 180))
      const offsetLng = midLng + (offsetDistance * Math.sin(offsetAngle * Math.PI / 180))

      return L.latLng(midLat, midLng)
    },

    clearLabels() {
      // 清除中心标签
      if (this.centerLabel) {
        this.map.removeLayer(this.centerLabel)
        this.centerLabel = null
      }

      // 清除边标签
      this.sideLabels.forEach(label => {
        this.map.removeLayer(label)
      })
      this.sideLabels = []

      // 清除面积标签
      this.areaLabels.forEach(label => {
        this.map.removeLayer(label)
      })
      this.areaLabels = []
    },

    toggleDrawMode(mode) {
      if (this.drawMode === mode) {
        this.drawMode = null
        this.map.removeControl(this.drawControl)
        this.showHintMessage('已退出绘制模式')
      } else {
        this.clearAll()
        this.drawMode = mode
        this.map.addControl(this.drawControl)

        // 激活对应绘制工具
        setTimeout(() => {
          const container = this.map._container
          const buttons = container.querySelectorAll('.leaflet-draw-draw-polygon')
          buttons.forEach(btn => {
            if (btn.className.includes(mode)) {
              btn.click()
            }
          })
        }, 100)

        this.showHintMessage(mode === 'polygon' ? '点击地图绘制多边形，点击第一个点完成' : '拖动绘制矩形')
      }
    },

    clearAll() {
      this.drawnItems.clearLayers()
      this.currentPolygon = null
      this.perimeter = 0
      this.area = 0
      this.areaMu = 0
      this.sideLengths = []
      this.drawMode = null
      this.map.removeControl(this.drawControl)
      this.clearLabels()
      this.showHintMessage('已清除所有图形')
    },

    //完成绘制
    finishDraw(){
      let container = this.map._container
      let toolBar = container.querySelectorAll('.leaflet-draw-actions');
      if(toolBar) {
        toolBar = toolBar[0];
        let buttons = toolBar.querySelectorAll('li a')
        if(buttons && buttons.length > 0) {
          buttons.forEach(function (link) {
            if (link.innerText == "完成") {
              link.click();
            }
          });
        }
      }
    },

    //撤销上一步
    undoStep(){
      let container = this.map._container
      let toolBar = container.querySelectorAll('.leaflet-draw-actions');
      if(toolBar) {
        toolBar = toolBar[0];
        let buttons = toolBar.querySelectorAll('li a')
        if(buttons && buttons.length > 0) {
          buttons.forEach(function (link) {
            if (link.innerText == "撤销") {
              link.click();
            }
          });
        }
      }
    },

    locateUser() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latlng = [position.coords.latitude, position.coords.longitude]
            this.userLocation = latlng

            if (this.userMarker) {
              this.map.removeLayer(this.userMarker)
            }

            this.userMarker = L.marker(latlng, {
              icon: L.divIcon({
                className: 'user-location-marker',
                html: '<div class="pulse"></div>',
                iconSize: [20, 20]
              })
            }).addTo(this.map)

            this.map.setView(latlng, 15)
            this.showHintMessage('已定位到您的位置')
          },
          (error) => {
            this.showHintMessage('定位失败，请检查位置权限')
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          }
        )
      } else {
        this.showHintMessage('您的浏览器不支持定位功能')
      }
    },

    addUserLocationMarker() {
      // 添加定位按钮到地图
      L.control.locate({
        position: 'topright',
        strings: {
          title: "定位到我的位置"
        },
        locateOptions: {
          maxZoom: 15,
          watch: true
        }
      }).addTo(this.map)
    },

    formatDistance(meters) {
      if (meters < 1000) {
        return `${Math.round(meters)}米`
      } else {
        return `${(meters / 1000).toFixed(2)}公里`
      }
    },

    formatArea(squareMeters) {
      return `${Math.round(squareMeters)}㎡`
      // if (squareMeters < 10000) {
      //   return `${Math.round(squareMeters)}㎡`
      // } else {
      //   return `${(squareMeters / 10000).toFixed(2)}公顷`
      // }
    },

    zoomIn() {
      this.map.zoomIn()
    },

    zoomOut() {
      this.map.zoomOut()
    },

    showHintMessage(text) {
      this.hintText = text
      this.showHint = true
      setTimeout(() => {
        this.showHint = false
      }, 3000)
    },

    setupMobileEvents() {
      let lastTouchEnd = 0
      this.map.getContainer().addEventListener('touchend', (event) => {
        const now = Date.now()
        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }
        lastTouchEnd = now
      }, false)
    },

    goBack() {
      this.$router.go(-1)
    },
    // 打开保存弹窗
    openSaveDialog() {
      if (!this.currentPolygon) {
        this.showHintMessage('请先绘制图形')
        return
      }
      // 如果已有保存的数据，可回显（可选）
      if (this.currentPolygon.userData) {
        this.formData = { ...this.currentPolygon.userData }
      } else {
        // 清空表单
        this.formData = {
          name: '',
          landType: '',
          years: null,
          contact: '',
          remarks: '',
          files: []
        }
      }
      this.dialogVisible = true
    },

    // 文件变化处理
    handleFileChange(file, fileList) {
      this.formData.files = fileList
    },

    // 保存表单数据到当前图形
    saveFormData() {
      if (!this.currentPolygon) {
        this.showHintMessage('请先绘制图形')
        return
      }
      // 1. 从图形中提取经纬度列表
      let latLngs = []
      if (this.currentPolygon instanceof L.Polygon || this.currentPolygon instanceof L.Rectangle) {
        // 获取多边形的第一个环（外环）
        const rawLatLngs = this.currentPolygon.getLatLngs()[0]
        // 转换为 [[lng, lat], ...] 格式
        latLngs = rawLatLngs.map(point => [point.lat.toFixed(6), point.lng.toFixed(6)])
      }
      // 2. 计算中心点作为经度/纬度字段
      const center = this.currentPolygon.getBounds().getCenter()
      // 3. 构造提交参数
      const params = {
        name: this.formData.name,
        landStatusValue: this.formData.landType, // 土地性质
        landUseYear: this.formData.years,         // 土地使用年限
        landPersonPhone: this.formData.contact,   // 联系人电话
        longitude: center.lng.toFixed(6),         // 中心点经度
        latitude: center.lat.toFixed(6),          // 中心点纬度
        positions: JSON.stringify(latLngs),       // 经纬度列表（JSON字符串）
        // 附件列表（如果有上传的文件）
        sysAttachmentList: this.formData.files.map(file => ({
          id: file.data, // 假设上传成功返回的文件对象包含 data 字段（文件ID）
          // 如果后端需要其他字段，根据实际情况补充
        }))
      }
      // 4. 调用新增接口
      addAlternativeSites(params).then(res => {
        if (res.code === 200) {
          this.showHintMessage('保存成功')
          this.dialogVisible = false
          // 可选：将返回的数据附加到图形上，方便后续编辑
          this.currentPolygon.userData = params
        } else {
          this.showHintMessage(res.msg || '保存失败')
        }
      }).catch(() => {
        this.showHintMessage('保存失败，请稍后重试')
      })

      // // 将表单数据附加到图形对象上
      // this.currentPolygon.userData = {
      //   name: this.formData.name,
      //   landType: this.formData.landType,
      //   years: this.formData.years,
      //   contact: this.formData.contact,
      //   remarks: this.formData.remarks,
      //   files: this.formData.files // 已是最新文件列表
      // }

      this.dialogVisible = false
      this.showHintMessage('地块信息已保存')

      // 可选：在标签上显示名称（如需）
      // 这里可根据需求决定是否更新图形上的标签
    },
    //获取字典
    getDicts() {
      getDicts("land_status_value").then(res =>{
        this.landStatusValue = res.data.map(p => ({ label: p.dictLabel, value: p.dictValue, elTagType: p.listClass, elTagClass: p.cssClass }))
      })
    },
  }
}
</script>

<style lang="scss" scoped>
#mobile-map-draw {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #f5f5f5;
  overflow: hidden;
}

.map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

#map {
  width: 100%;
  height: 100%;
  background: #e6e6e6;
}

/* 移动端顶部工具栏 */
.mobile-toolbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4));
  padding: env(safe-area-inset-top) 10px 10px;
  backdrop-filter: blur(10px);
}

.toolbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.title {
  font-size: 18px;
  color: white;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.back-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  border-radius: 15px;
  padding: 4px 12px;
  font-size: 12px;

  &:active {
    background: rgba(255, 255, 255, 0.3);
  }
}

/* 移动端底部操作栏 */
.mobile-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4));
  padding: 10px 10px calc(10px + env(safe-area-inset-bottom));
  backdrop-filter: blur(10px);
}

.control-buttons {
  display: flex;
  justify-content: space-around;
  gap: 8px;
}

.control-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 10px;
  padding: 10px 5px;
  min-height: 60px;
  transition: all 0.2s ease;

  &:active {
    background: rgba(255, 255, 255, 1);
    transform: scale(0.95);
  }

  &.active {
    background: #1890ff;
    color: white;

    .btn-icon,
    .btn-text {
      color: white;
    }
  }
}

.btn-icon {
  font-size: 20px;
  margin-bottom: 4px;
  color: #1890ff;
}

.btn-text {
  font-size: 12px;
  color: #333;
  font-weight: 500;
}

/* 缩放控制 */
.zoom-controls {
  position: absolute;
  right: 10px;
  bottom: 80px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.zoom-btn {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 20px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  &:active {
    background: white;
    transform: scale(0.95);
  }
}

/* 操作提示 */
.hint-tooltip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2000;
  animation: fadeInOut 3s ease;
}

@keyframes fadeInOut {

  0%,
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }

  20%,
  80% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.hint-content {
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 12px 20px;
  border-radius: 20px;
  font-size: 14px;
  text-align: center;
  backdrop-filter: blur(10px);
  max-width: 280px;
}

/* 用户位置标记样式 */
:deep(.user-location-marker) {
  .pulse {
    width: 20px;
    height: 20px;
    background: #1890ff;
    border-radius: 50%;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #1890ff;
      border-radius: 50%;
      animation: pulse 1.5s infinite;
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}

/* 图形上的标签样式 */
:deep(.area-label) {
  background: transparent;
  border: none;

  .area-label-content {
    // background: rgba(255, 255, 255, 0.95);
    // border: 2px solid #1890ff;
    border-radius: 20px;
    padding: 8px 12px;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    text-align: left;
    // backdrop-filter: blur(5px);

    .area-main {
      font-size: 14px;
      color: red;
      font-weight: bold;
      line-height: 1.2;
    }

    .area-details {
      font-size: 12px;
      color: white;
      margin-top: 2px;
    }
  }
}

:deep(.side-label) {
  background: transparent;
  border: none;

  .side-label-content {
    // background: rgba(255, 255, 255, 0.9);
    // border: 1px solid #52c41a;
    border-radius: 6px;
    padding: 2px 6px;
    // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
    // backdrop-filter: blur(5px);

    .side-length {
      font-size: 11px;
      color: white;
      font-weight: bold;
      line-height: 1.2;
    }

    .side-angle {
      font-size: 9px;
      color: #fa8c16;
      line-height: 1.1;
    }
  }
}

/* 确保标签不会被遮罩 */
:deep(.leaflet-marker-icon) {
  z-index: 1000 !important;
}

/* 响应式调整 */
@media (max-width: 320px) {
  .control-btn {
    min-height: 50px;
    padding: 8px 3px;
  }

  .btn-icon {
    font-size: 18px;
  }

  .btn-text {
    font-size: 11px;
  }
}

@media (min-width: 768px) {
  .control-buttons {
    max-width: 500px;
    margin: 0 auto;
  }
}

/* 防止移动端浏览器工具栏遮挡 */
@supports (padding: max(0px)) {
  .mobile-toolbar {
    padding-top: max(10px, env(safe-area-inset-top));
  }

  .mobile-controls {
    padding-bottom: max(10px, env(safe-area-inset-bottom));
  }
}

/* 优化标签显示，在缩放时保持可读性 */
:deep(.leaflet-zoom-animated) {

  .area-label-content,
  .center-label-content,
  .side-label-content {
    transform: scale(calc(1 / var(--leaflet-scale, 1)));
    transform-origin: center;
  }
}

/* 确保上传组件适配移动端 */
.el-upload__tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

</style>